import React, { useState, useEffect } from 'react';

// ux
import LoadingAnimationSimple from '../ux/LoadingAnimationSimple';

const FusionCreator = ({
  fuse,
  isNewFuse,
  handleOpenModal,
  loadingContent,
  pinImage,
  fuseShareId,
  ideaID,
  handleRetry
}) => {
  const [currentIdea, setCurrentIdea] = useState('');
  const [currentIdeaIndex, setCurrentIdeaIndex] = useState(0);
  const [currentContentIdeas, setCurrentContentIdeas] = useState([]);

  // Initial current idea should be fuse.fuse_ideas[0].fuse_idea on initial load
  useEffect(() => {
    if (!isNewFuse) {
      if (fuse && fuse.fuse_ideas && fuse.fuse_ideas.length > 0) {
        setCurrentIdea(fuse.fuse_ideas[0].fuse_idea);
        setCurrentContentIdeas(fuse.fuse_ideas[0].content_ideas || []);
        setCurrentIdeaIndex(0);
      }
    }
  }, []);

  // When fuse is updated to include new ideas, update current idea
  useEffect(() => {
    if (isNewFuse) {
      if (fuse && fuse.fuse_ideas && fuse.fuse_ideas.length > 0) {
        setCurrentIdea(fuse.fuse_ideas[0].fuse_idea);
        setCurrentContentIdeas(fuse.fuse_ideas[0].content_ideas || []);
        setCurrentIdeaIndex(0);
      }
    }
  }, [fuse, isNewFuse]);

  // When fuse is updated to include new ideas, update current idea and content ideas
  useEffect(() => {
    if (
      fuse &&
      fuse.fuse_ideas &&
      fuse.fuse_ideas.length > 0 &&
      fuse.fuse_ideas[currentIdeaIndex] !== undefined
    ) {
      setCurrentContentIdeas(
        fuse.fuse_ideas[currentIdeaIndex].content_ideas || []
      );
    }
  }, [fuse, currentIdeaIndex]);

  // on handlePinImage, make the correct idea.pinned = true and all other idea.pinned = false
  const handlePinImage = (index) => {
    const newContentIdeas = currentContentIdeas.map((idea, i) => {
      if (i === index) {
        return { ...idea, pinned: !idea.pinned };
      } else {
        return { ...idea, pinned: false };
      }
    });
    setCurrentContentIdeas(newContentIdeas);
    pinImage(fuse.ID, newContentIdeas);
  };

  return (
    <div className="fuselight-fuse-idea">
      {loadingContent ? (
        <div className="loading-animation-flex">
          <LoadingAnimationSimple />
        </div>
      ) : currentContentIdeas.length > 0 ? (
        <div className="social-tiles">
          {currentContentIdeas.map((idea, index) => {
            const modalInfo = {
              index: index,
              ideaID: ideaID
            };
            return (
              <div key={index} className="social-tile">
                {!fuseShareId && (
                  <button
                    onClick={() => handlePinImage(index)}
                    className={
                      idea.pinned === true
                        ? 'tile-bookmark active'
                        : 'tile-bookmark'
                    }
                  >
                    <i className="fas fa-bookmark"></i>
                  </button>
                )}
                <div
                  className="social-tile-content"
                  onClick={() => handleOpenModal('ideas', modalInfo)}
                >
                  {idea.idea_image_url ? (
                    <img
                      src={idea.idea_image_url}
                      alt="Fuselight AI generated image"
                    />
                  ) : (
                    <p>No image available</p>
                  )}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: idea.idea_content
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="retry-flex">
          <p className="retry-header">Something went wrong...</p>
          <button className="btn btn--primary-outline" onClick={handleRetry}>
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

export default FusionCreator;
